import { inject, Injectable } from '@angular/core';
import { portalConst } from '@app/config';
import { Observable } from 'rxjs';
import { ApiService, Resp } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class GradeService {
  private readonly _api = inject(ApiService);

  private readonly _url = `${portalConst.api.eclass}/v1/grades`;

  public list(data?: any): Observable<Resp<any[]>> {
    return this._api.get<any[]>(`${this._url}`, data);
  }
}
